if (!customElements.get('size-chart-modal-tiles')) {
  class SizeChartModalTiles extends HTMLElement {
    constructor() {
      super()
      this.content = this.querySelector('.size-chart-modal-tiles__content')
    }

    connectedCallback() {
      this.boundClose = this.close.bind(this)
      this.boundStop = function stopPropagation(e) {
        e.stopPropagation()
      }
      this.boundChange = this.handleChange.bind(this)
      this.boundKeydown = this.handleKeydown.bind(this)

      this.addEventListener('click', this.boundClose)
      this.content.addEventListener('click', this.boundStop)
      this.addEventListener('change', this.boundChange)
      this.querySelector('.js-close').addEventListener('click', this.boundClose)
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.boundClose)
      this.content.removeEventListener('click', this.boundStop)
      this.removeEventListener('change', this.boundChange)
      this.querySelector('.js-close').removeEventListener('click', this.boundClose)
    }

    // a11y: Escape closes; focus moves in on open and returns to the trigger on close.
    handleKeydown(e) {
      if (e.key === 'Escape') this.close()
    }

    open() {
      this.opener = document.activeElement
      this.classList.add('is-open')
      this.removeAttribute('inert')
      document.addEventListener('keydown', this.boundKeydown)
      this.querySelector('.js-close')?.focus()
    }

    close() {
      this.classList.remove('is-open')
      this.setAttribute('inert', '')
      document.removeEventListener('keydown', this.boundKeydown)
      if (this.opener && document.contains(this.opener)) this.opener.focus()
      this.opener = null
    }

    handleChange(e) {
      if (e.target.name !== 'size-unit') return
      const value = e.target.value
      this.content.querySelectorAll('[data-unit-system]').forEach(function toggleUnit(container) {
        if (container.dataset.unitSystem === value) {
          container.classList.remove('hidden')
        } else {
          container.classList.add('hidden')
        }
      })
    }
  }
  customElements.define('size-chart-modal-tiles', SizeChartModalTiles)
}
